__webpack_require__.p = "/infomap/";